import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { extendStore } from '@vue-storefront/core/helpers'
import { loginCodeStore } from './store'
import { USER_REFRESH_TOKEN_CLEARED } from './store/mutation-types'

export const LOGIN_CODE_STORE_KEY = 'login-code'

const userStoreExtension = {
  mutations: {
    [USER_REFRESH_TOKEN_CLEARED] (state) {
      state.refreshToken = ''
    }
  }
}

export const LoginCode: StorefrontModule = function ({ store }) {
  store.registerModule(LOGIN_CODE_STORE_KEY, loginCodeStore)
  extendStore('user', userStoreExtension)
}
